﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_shopList from './tpl/shopList.html';
import View_ShopListItem from './shopListItem';

export default Marionette.CollectionView.extend({
    tagName: 'ul',
    className :'product-grid row listview',
    childViewContainer: '#shopList',
    childView: View_ShopListItem,
    getTemplate: function () {
        return tpl_shopList();
    },
    initialize: function () {
        this.app = this.options.app;

        this.listenTo(this.collection, 'change', this.render);
    },
    buildChildView: function(child, ChildViewClass, childViewOptions){
        var options = _.extend({model: child}, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    }
});
